// resources
import teacherEndpoints from 'api/resources/teacher';
import { isRoleType } from 'lib/helpers';
import { ROLES_OBJECT } from 'constants/onBoarding';

const {
  putTeacherByCenterId,
  putTeacherByCenterIdAsTeacher,
  deleteTeacherAsOwnerByCenterId,
  getTeacherByCenterIdAsTeacher,
  getTeacherByCenterIdAsAdmin,
} = teacherEndpoints;

const configQuery = {
  retry: false,
  enabled: false,
  refetchOnMount: true,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
};

// eslint-disable-next-line import/prefer-default-export
export const teacherQuery = {
  getTeacher: {
    key: 'teacher',
    config: configQuery,
    resource: ({ teacherId, centerId }) => {
      if (!isRoleType([ROLES_OBJECT.TEACHER.value])) {
        return getTeacherByCenterIdAsAdmin(centerId, teacherId);
      }
      return getTeacherByCenterIdAsTeacher(centerId, teacherId);
    },
  },
  editTeacher: {
    key: 'teacher',
    config: configQuery,
    resource: (teacher, centerId, teacherId) => {
      if (!isRoleType([ROLES_OBJECT.TEACHER.value])) {
        return putTeacherByCenterId(
          { ...teacher },
          centerId,
          teacherId,
        );
      }
      return putTeacherByCenterIdAsTeacher({ ...teacher }, centerId, teacherId);
    },
  },
  deleteTeacher: {
    config: configQuery,
    key: 'delete-teacher',
    resource: deleteTeacherAsOwnerByCenterId,
  },
};
